import React from "react";
import DatePicker, {
  registerLocale,
  ReactDatePickerProps,
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ja } from "date-fns/locale";

import clsx from "clsx";
registerLocale("ja", ja);

type Props = ReactDatePickerProps & {
  error?: string | boolean;
  placeholder?: string;
};

export const DatePickerInput = (props: Props) => {
  const css = clsx("c-form-field", props.error && "invalid");
  return (
    <DatePicker
      {...props}
      locale="ja"
      dateFormat="yyyy/MM/dd"
      dateFormatCalendar="yyyy年 LLLL"
      className={css}
      placeholderText={props.placeholder}
      todayButton="今日"
    />
  );
};
DatePickerInput.defaultProps = {
  placeholder: "日付を選択してください",
};
